import { useState, useEffect, useRef } from 'react'
import { collection, getDocs } from 'firebase/firestore/lite';
import { db } from '../services/firebase/config';

export const useGetCollection = (name) => {

    //para evitar el erorr de cargado en 04-useRef de que si corto la ejecucio de la carga de este componente da erro (vamos usar useref)
    const ref = useRef(true)

    //si dento la carga el useEfect cuando deje de aser referencia al 
    //si corto esto el componete pasa a false pero eso me matiene la rerecia
    //y evita errores en la consolo
    useEffect(() => {
        return () => {
            ref.current = false
        }
    }, [])

    const [state, setstate] = useState({
        data: null,
        loadin: true,
        erro: null,
    });

    useEffect(() => {
        setstate({ data: null, loadin: true, error: null })

        const getCollections = async () => {
            const collections = collection(db, name);
            const collectionSnapShot = await getDocs(collections);
            const collectionList = collectionSnapShot.docs.map(doc => doc.data());
            setstate({ data: collectionList, loadin: false, error: null })
        }

        getCollections();
    }, [])//quiero que se ejecute cuando la url cambie


    return state

}